import * as React from "react";
import ReactMarkdown from "react-markdown";
import { FileItem } from "@/types/fse";

interface Props {
  item: FileItem;
}

export const DriveRowSummary: React.FC<Props> = ({ item }) => (
  <div
    data-testid="drive-row-summary"
    className="flex justify-center border-t border-desert-sand-200 bg-ivory-mist-100 px-4"
  >
    <div className="my-8 w-full max-w-[750px] bg-ui-app-background py-8">
      <div className="prose prose-sm max-w-none px-6">
        <ReactMarkdown
          components={{
            h1: ({ ...props }) => <h1 className="mb-4 text-center text-2xl font-bold" {...props} />,
            h2: ({ ...props }) => <h2 className="mb-3 text-center text-xl font-semibold" {...props} />,
            h3: ({ ...props }) => <h3 className="mb-2 text-lg font-semibold" {...props} />,
            p: ({ ...props }) => <p className="mb-4 text-base leading-relaxed" {...props} />,
            ul: ({ ...props }) => <ul className="mb-4 list-inside list-disc pl-4" {...props} />,
            ol: ({ ...props }) => <ol className="mb-4 list-inside list-decimal pl-4" {...props} />,
            li: ({ ...props }) => <li className="mb-2" {...props} />,
            strong: ({ ...props }) => <strong className="font-bold" {...props} />,
            em: ({ ...props }) => <em className="italic" {...props} />,
          }}
        >
          {item.small_summary}
        </ReactMarkdown>
      </div>
    </div>
  </div>
);
